require('./umDropdownListItemScrollIntoView');

/*@ngInject*/
const DropdownListController = function ($scope, $element, $timeout, coreConstant) {

    const timeoutList = [];

    let currentHighlightedItem = null;

    this.$onInit = function () {
        $element.addClass('umDropdownListComponent');

        this.itemsList = this.itemsList || [];
    };

    this.$onChanges = function (changes) {
        const isOptionListChange = !_.isEmpty(changes.optionList);

        if (isOptionListChange) {
            this.processOptionList();
            timeoutList.push($timeout(function () {
                const selectedElement = $element.find('.selected');
                if (selectedElement.length) {
                    selectedElement[0].scrollIntoView({block: 'center'});
                }
            }, 100));
        }
    };

    this.processOptionList = function () {
        const groupings = [];
        const itemsByGrouping = {};

        _.each(this.optionList, (item) => {
            if (!_.includes(groupings, item.grouping)) {
                itemsByGrouping[item.grouping || ''] = [];
                groupings.push(item.grouping);
            }

            this.unhighlightItem(item);

            itemsByGrouping[item.grouping || ''].push(item);
        });

        this.itemsList = [];
        _.forOwn(itemsByGrouping, (items, grouping) => {
            this.itemsList.push({
                isGroupingLabel: true,
                grouping: grouping
            });

            this.itemsList = _.concat(this.itemsList, items);
        });

        this.itemsListWithoutGroupings = _.filter(this.itemsList, function (item) {
            return !item.isGroupingLabel;
        });

        if (!_.isEmpty(this.searchTerm) && !_.isEmpty(this.itemsListWithoutGroupings)) {
            this.highlightItem(_.first(this.itemsListWithoutGroupings));
        }
    };

    this.onMouseOver = function (item) {
        item.mouseOver = true;
        this.highlightItem(item);
    };

    this.onMouseLeave = function (item) {
        item.mouseOver = false;
        this.unhighlightItem(item);
    };

    this.findItemToHighlight = function (up) {
        let itemToHighlight = null;

        if (up) {
            if (_.isNil(currentHighlightedItem)) {
                itemToHighlight = _.last(this.itemsListWithoutGroupings);
            } else {
                const currentHighlightedItemIndex = _.findIndex(this.itemsListWithoutGroupings, function (item) {
                    return item === currentHighlightedItem;
                });
                if (currentHighlightedItemIndex === 0) {
                    itemToHighlight = _.last(this.itemsListWithoutGroupings);
                } else {
                    itemToHighlight = this.itemsListWithoutGroupings[currentHighlightedItemIndex - 1];
                }
            }
        } else {
            if (_.isNil(currentHighlightedItem)) {
                itemToHighlight = _.first(this.itemsListWithoutGroupings);
            } else {
                const currentHighlightedItemIndex = _.findIndex(this.itemsListWithoutGroupings, function (item) {
                    return item === currentHighlightedItem;
                });

                if (currentHighlightedItemIndex === _.size(this.itemsListWithoutGroupings) - 1) {
                    itemToHighlight = _.first(this.itemsListWithoutGroupings);
                } else {
                    itemToHighlight = this.itemsListWithoutGroupings[currentHighlightedItemIndex + 1];
                }
            }
        }

        return itemToHighlight;
    };

    this.handleDropdownHighlightChange = function (up) {
        const itemToHighlight = this.findItemToHighlight(up);

        this.highlightItem(itemToHighlight);
    };

    this.highlightItem = function (item) {
        _.map(this.itemsListWithoutGroupings, function (item) {
            item.highlighted = false;
        });

        item.highlighted = true;
        currentHighlightedItem = item;
    };

    this.unhighlightItem = function (item) {
        item.highlighted = false;
        currentHighlightedItem = null;
    };

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_UP, () => {
        this.handleDropdownHighlightChange(true);
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_DOWN, () => {
        this.handleDropdownHighlightChange(false);
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_SELECT_HIGHLIGHTED_ITEM, () => {
        if (!_.isNil(currentHighlightedItem)) {
            this.onSelect({option: currentHighlightedItem});
            timeoutList.push($timeout(function () {}, 0));
        }
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umCore')
    .controller('umDropdownListController', DropdownListController);
